<template>
    <div class="features-list">
        <common-page-header
            :heading="$t('pages.billing.billing.features')"
            size="page-plain-header"
            contentSpacing="medium"
            :isCenter="isHeaderCenter"
        ></common-page-header>
        <p v-for="(value, key) in featuresList" :key="key" class="features-list--item">
            <common-icon name="check-blue" size="small"></common-icon>
            {{ value }}
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            featuresList: { type: Array, required: true },
            isHeaderCenter: { type: Boolean, default: true },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/practice-billing/_billing-features-list.scss';
</style>
